import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  Typography
} from '@mui/material';

import {
  KeyOutlined,
  PersonOutlineOutlined,
  VpnKeyOutlined
} from '@mui/icons-material';

import {
  cardHeaderSx,
  cardTitleSx,
  changePasswordButtonSx,
  passwordCardSx,
  passwordContentSx,
  providerIconSx,
  providerLabelSx,
  providerValueSx,
  usernameFieldSx
} from './styles';

const PasswordSettingsCard = ({
  onChangePassword,
  userName
}) => (
  <Box sx={passwordCardSx}>
    <Box sx={cardHeaderSx}>
      <Typography sx={cardTitleSx}>
        Password Settings
      </Typography>
    </Box>

    <Box sx={passwordContentSx}>
      <Box sx={usernameFieldSx}>
        <PersonOutlineOutlined sx={providerIconSx} />

        <Box>
          <Typography sx={providerLabelSx}>
            User Name
          </Typography>

          <Typography sx={providerValueSx}>
            {userName}
          </Typography>
        </Box>
      </Box>

      <Button
        onClick={onChangePassword}
        startIcon={<VpnKeyOutlined />}
        sx={changePasswordButtonSx}
      >
        Change Password
      </Button>
    </Box>
  </Box>
);

PasswordSettingsCard.propTypes = {
  onChangePassword: PropTypes.func.isRequired,
  userName: PropTypes.string.isRequired
};

export default PasswordSettingsCard;